import { render, staticRenderFns } from "./SiniestroMovilidad.vue?vue&type=template&id=4b294766&scoped=true&"
import script from "./SiniestroMovilidad.vue?vue&type=script&lang=js&"
export * from "./SiniestroMovilidad.vue?vue&type=script&lang=js&"
import style0 from "./SiniestroMovilidad.vue?vue&type=style&index=0&id=4b294766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b294766",
  null
  
)

export default component.exports